export const getOrdersByClientByDate = /* GraphQL */ `
  query GetOrdersByClientByDate(
    $clientId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrdersByClientByDate(
      clientId: $clientId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        restaurantId
        elderId
        date
        mealSlot
        deliveryBy
        status
        county
        deliveryGroupId
        deliveryGroupSortOrder
        deliveryStaffId
        deliveryStaffOrderId
        deliveryStaffFee
        noteForMeal
        mealItems {
          name
          quantity
          price
          cost
          note
        }
        totalCost
        total
        quantity
        subtotal
        createdAt
        elder {
          id
          name
          tags {
            items {
              id
              tagId
              tag {
                id
                category
                subcategory
                color
                label
              }
            }
            nextToken
          }
        }
        restaurant {
          id
          name
        }
      }
      nextToken
    }
  }
`;

export const getElderDeliveryGroupsByClientByStatus = /* GraphQL */ `
  query GetElderDeliveryGroupsByClientByStatus(
    $clientId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelElderDeliveryGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getElderDeliveryGroupsByClientByStatus(
      clientId: $clientId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        elderId
        deliveryGroupId
        clientId
        status
        sortOrder
        deliveryGroup {
          name
        }
      }
      nextToken
    }
  }
`;
